import { vPurifyHtml } from '@nxtpeople/nxt-styles';
import {
   Capitalize,
   DateFormatter,
   DateTimeFormatter,
   FontColorContraster,
   LowerCase,
   OutsideMousedownDirective,
   PhoneFormatter,
   TimeFormatter,
   UpperCase,
} from '@nxtpeople/nxt-vue-library';
import { App } from 'vue';
import { AddressFormatter } from '../directives/address-formatter.directive';

function setupDirectives(app: App<Element>) {
   app.directive('date-time', DateTimeFormatter);
   app.directive('date', DateFormatter);
   app.directive('time', TimeFormatter);
   app.directive('address', AddressFormatter);
   app.directive('phone', PhoneFormatter);
   app.directive('font-color-contrast', FontColorContraster);
   app.directive('uppercase', UpperCase);
   app.directive('lowercase', LowerCase);
   app.directive('capitalize', Capitalize);
   app.directive('outside-mouse-down', OutsideMousedownDirective);
   app.directive('html', vPurifyHtml);
}

export { setupDirectives };
